// import { reportConsole } from "./common/utilities/logging-utilities";
import GenesysCloudAPI from "./components/common/static/GenesysCloudAPI";

// private config
const headerTitle = "Knowledge base connector";

const provisioningInfo = {
  // groupAdmin: {
  //   name: "Appfoundry Admin Group",
  //   description:
  //     "Group used to manage individual instance settings and deployment information inside of Application.",
  //   type: "official",
  //   visibility: "members",
  //   rulesVisible: true,
  // },
  // groupUser: {
  //   name: "Appfoundry User Group",
  //   description:
  //     "Group used to manage individual instance basic user access and interaction for the Application.",
  //   type: "official",
  //   visibility: "members",
  //   rulesVisible: true,
  // },
  roles: [
    {
      "id": 'gcAdmin',
      "description": 'Role used to manage individual instance settings and deployment information inside of Application.',
      "name": "KBC Installation Wizard Admin",
      "permissions": [],
      "policies": [
        { 
          "domain": "knowledge",
          "entityName": "document", 
          "actionSet": ["*"] 
        },
        {
          "domain": "knowledge",
          "entityName": "documentVersion",
          "actionSet": ["*"]
        },
        { 
          "domain": "responseAssets", 
          "entityName": "*", 
          "actionSet": ["*"] 
        },
        { 
          "domain": "responses", 
          "entityName": "response", 
          "actionSet": ["*"] 
        }
      ]
    },
    {
      "id": 'sharepointAdmin',
      "description": "Full access to create and manage knowledge bases, SharePoint connections, and trigger configurations",
      "name": "SharePoint Connector Admin",
      "permissions": [],
      "policies": []
    },
    {
      "id": 'sharepointView',
      "description":  "Can view knowledge bases and SharePoint content, but cannot modify settings",
      "name": "SharePoint Connector View",
      "permissions": [],
      "policies": []
    }


  ]

};

const baseConfiguration: any = {
  app: {
    title: headerTitle,
    storageVersion: "v1",
    solutionKey: "genesys-kbc",
    solutionName: headerTitle,
    bypassEnvs: ["local"],
    afAllowedEnvs: ["production"],
    internalAllowedEnvs: ["development", "test", "production"],
    authentication: "genesys-cloud",
    color: {
      genesysPrimaryColor: "#23395d",
      genesysSecondaryColor: "#ff4f1f",
      genesysBtnBgColor: "#2d4b7c",
    },
  },
  client: "ee4b316f-ac67-4e6c-9598-691a1dab6f6c",
  sandbox_client: "cf29d6cf-7987-49e4-bae7-34062a60082b",
  endpoints: {
    local: {
      apac: {
        endpoint: 'https://2xhts2vj2f.execute-api.ap-south-1.amazonaws.com/dev',
        baseUrl: 'https://d1acfe6ld31y9h.cloudfront.net'
      }
    },
    dev: {
      apac: {
        endpoint: 'https://2xhts2vj2f.execute-api.ap-south-1.amazonaws.com/dev',
        baseUrl: 'https://d3ukkwy0mf0w28.cloudfront.net'
      }
    },
    test: {},
    sandbox: {
      apac: { 
        endpoint: 'https://yvt92i9uek.execute-api.ap-south-1.amazonaws.com/sandbox',
        baseUrl: 'https://d3tdxc03vr737f.cloudfront.net'
      }
      
    },
    prod: {
      us: {
        endpoint: 'https://l4hj4cq36b.execute-api.us-west-2.amazonaws.com/prod',
        baseUrl: 'https://d3ldv95nx5g9da.cloudfront.net'
      },
      eu: {
        endpoint: 'https://0dwvnevsac.execute-api.eu-central-1.amazonaws.com/prod',
        baseUrl: 'https://d3ldv95nx5g9da.cloudfront.net'
      },
      apac: {
        endpoint: 'https://umnekzr1y9.execute-api.ap-south-1.amazonaws.com/prod',
        baseUrl: 'https://d3ldv95nx5g9da.cloudfront.net'
      },
      emea: {
        endpoint: 'https://umnekzr1y9.execute-api.ap-south-1.amazonaws.com/prod',
        baseUrl: 'https://d3ldv95nx5g9da.cloudfront.net'
      }
    }
  },
 
  appfoundryAppId: {
    local: ["premium-app-custom-application"],
    dev: ["premium-app-custom-application"],
    test: ["premium-app-custom-application"],
    production: ["premium-app-custom-application"],
  },
};

console.log("printing REACT_APP_ENV", process.env.REACT_APP_ENV)
const env: string = process.env.REACT_APP_ENV || 'local';
console.log("printing env", env)

// Function to get environment from URL query parameters
const getEnvironmentFromUrl = (): string => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('environment') || '';
  }
  return '';
}

// Function to find API mapping by environment string
const findApiMappingByEnv = (envString: string): any => {
  if (!envString) return null;
  
  // Direct match first
  let apiMapping = GenesysCloudAPI.find(mapping => mapping.env === envString);
  
  if (!apiMapping) {
    // Partial match
    apiMapping = GenesysCloudAPI.find(mapping => 
      envString.includes(mapping.env) || mapping.env.includes(envString)
    );
  }
  
  if (!apiMapping) {
    // Domain-based matching
    const cleanEnv = envString.replace(/^https?:\/\//, '').split('/')[0];
    apiMapping = GenesysCloudAPI.find(mapping => {
      const cleanMappingEnv = mapping.env.replace(/^https?:\/\//, '').split('/')[0];
      return cleanEnv === cleanMappingEnv || cleanEnv.includes(cleanMappingEnv) || cleanMappingEnv.includes(cleanEnv);
    });
  }
  
  return apiMapping;
}

// Function to determine region based on AWS region
const getRegionFromAwsRegion = (awsRegion: string): 'us' | 'eu' | 'apac' | 'emea' => {
  // support Canada, south america to us (aws: 'ca-central-1', aws: 'sa-east-1')
  if (awsRegion.startsWith('us-') || awsRegion.startsWith('ca-') || awsRegion.startsWith('sa-')) {
    return 'eu';
  }
  if (awsRegion.startsWith('eu-')) {
    return 'eu';
  }
  
  if (awsRegion.startsWith('ap-')) {
    return 'apac';
  }

  if (awsRegion.startsWith('me-')) {
    return 'emea';
  }
  
  return 'us';
}

// Get URL environment parameter
const urlEnv = getEnvironmentFromUrl();
const apiMapping = findApiMappingByEnv(urlEnv);
const region = apiMapping ? getRegionFromAwsRegion(apiMapping.aws) : 'us';

// Function to get regional endpoints based on environment and region
const getRegionalEndpoints = (env: string, region: 'us' | 'eu' | 'apac' | 'emea', apiMapping: any): any => {
  // Get base endpoints for the environment
  const envEndpoints = baseConfiguration.endpoints[env];
  console.log(`Env endpoints`, envEndpoints)
  if (!envEndpoints) {
    console.warn(`No endpoints found for environment: ${env}, using local`);
    return {
      ...baseConfiguration.endpoints.local[region],
      apiGateway: apiMapping?.api || GenesysCloudAPI.find(m => m.aws === 'us-east-1')?.api,
      apps: apiMapping?.apps || GenesysCloudAPI.find(m => m.aws === 'us-east-1')?.apps
    };
  }
  
  // Get regional endpoint
  const regionalEndpoint : any = envEndpoints[region] || envEndpoints.us || envEndpoints;
  
  console.log("regg", regionalEndpoint, regionalEndpoint.endpoint)
  return { endpoint: regionalEndpoint.endpoint};
}

const local = {
  app: {
    ...baseConfiguration.app,
    appFoundry: {
      provisioningInfo: {
        ...provisioningInfo,
      },
      appFoundryAppId: baseConfiguration.appfoundryAppId.local,
    },
  },
  client: baseConfiguration.client,
  endpoints: {
    ...getRegionalEndpoints(env, 'apac', apiMapping)
  }
};

const development = {
  app: {
    ...baseConfiguration.app,
    appFoundry: {
      provisioningInfo: {
        ...provisioningInfo,
      },
      appFoundryAppId: baseConfiguration.appfoundryAppId.dev,
    },
  },
  client: baseConfiguration.client,
  endpoints: {
    ...getRegionalEndpoints(env, 'apac', apiMapping)
  }
};

const test = {
  app: {
    ...baseConfiguration.app,
    appFoundry: {
      provisioningInfo: {
        ...provisioningInfo,
      },
      appFoundryAppId: baseConfiguration.appfoundryAppId.test,
    },
  },
  client: baseConfiguration.client,
  endpoints: {
    ...getRegionalEndpoints(env, 'apac', apiMapping)
  }
};

const sandbox = {
  app: {
    ...baseConfiguration.app,
    appFoundry: {
      provisioningInfo: {
        ...provisioningInfo,
      },
      appFoundryAppId: baseConfiguration.appfoundryAppId.dev,
    },
  },
  client: baseConfiguration.sandbox_client,
  endpoints: {
    ...getRegionalEndpoints(env, 'apac', apiMapping)
  }
};


const production = {
  app: {
    ...baseConfiguration.app,
    appFoundry: {
      provisioningInfo: {
        ...provisioningInfo,
      },
      appFoundryAppId: baseConfiguration.appfoundryAppId.production,
    },
  },
  client: baseConfiguration.client,
  endpoints: {
    ...getRegionalEndpoints(env, region, apiMapping)
  }
};







const build = "";
console.log(
  "Knowledge base connector---> Found an issue, or need to report a bug. Please reach out to Genesys Cloud representative or support.",
  "info"
);
console.log(
  "Knowledge base connector---> Application Environment: %o",
  "info",
  env
);
console.log(
  "Knowledge base connector ---> Application Version: %o",
  "info",
  env === "local" ? "local build" : build
);

let config: any = {} ;
switch (env) {
  case "prod":
    config = production;
    
    break;
  case "sandbox":
    config = sandbox;
    break;
  case "test":
    config = test;
    break;
  case "development":
    config = development;
    break;
  case "local":
    config = local;
    console.log("config", config);
    break;
  default:
    break;
}

console.log(
  "KBC---> Using OAUTH Client: %o",
  "info",
  config.client
);

export default config;
